module.exports = __webpack_public_path__ + "static/media/jerome.5eb7d0cd.jpg";